import { NativeBridge, isReactNativeWebView } from "../../bridge/nativeBridge";
import {
  NATIVE_BRIDGE_INBOUND,
  NATIVE_BRIDGE_OUTBOUND,
} from "../constant/nativeBridgeMessages";

const BRIDGE_TIMEOUT_MS = 12_000;

/** Session flag: after explicit logout, skip one auto-login attempt. */
export const KEYCHAIN_LOGIN_SKIP_ONCE_KEY = "cms_keychain_login_skip_once";

function createRequestId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `req_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

/**
 * @returns {Promise<{ email: string, password: string } | null>}
 */
export async function loadLoginCredentialsFromNative() {
  if (!isReactNativeWebView()) return null;

  return new Promise((resolve) => {
    const requestId = createRequestId();
    let done = false;

    const finish = (value) => {
      if (done) return;
      done = true;
      window.clearTimeout(tid);
      unsubscribe();
      resolve(value);
    };

    const tid = window.setTimeout(() => finish(null), BRIDGE_TIMEOUT_MS);

    const unsubscribe = NativeBridge.listen((raw) => {
      if (typeof raw !== "object" || raw === null || !("type" in raw)) {
        return;
      }
      const msg = raw;
      const p = msg.payload || {};
      if (p.requestId !== requestId) return;

      if (msg.type === NATIVE_BRIDGE_INBOUND.LOGIN_CREDENTIALS_LOADED) {
        // Native may echo loginId (CRM pattern) or email
        const email = String(p.email ?? p.loginId ?? "").trim();
        const password = String(p.password ?? "");
        if (!email || !password) {
          finish(null);
          return;
        }
        finish({ email, password });
        return;
      }
      if (msg.type === NATIVE_BRIDGE_INBOUND.LOGIN_CREDENTIALS_ERROR) {
        finish(null);
      }
    });

    NativeBridge.send(NATIVE_BRIDGE_OUTBOUND.LOAD_LOGIN_CREDENTIALS, {
      requestId,
    });
  });
}

export function saveLoginCredentialsToNative(email, password) {
  if (!isReactNativeWebView()) return;
  const id = String(email || "").trim();
  if (!id || !password) return;
  NativeBridge.send(NATIVE_BRIDGE_OUTBOUND.SAVE_LOGIN_CREDENTIALS, {
    loginId: id,
    email: id,
    password,
  });
}

export function clearLoginCredentialsFromNative() {
  if (!isReactNativeWebView()) return;
  NativeBridge.send(NATIVE_BRIDGE_OUTBOUND.CLEAR_LOGIN_CREDENTIALS, {});
}

export function markSkipKeychainAutoLoginOnce() {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(KEYCHAIN_LOGIN_SKIP_ONCE_KEY, "1");
}

export function consumeSkipKeychainAutoLoginOnce() {
  if (typeof window === "undefined") return false;
  if (window.sessionStorage.getItem(KEYCHAIN_LOGIN_SKIP_ONCE_KEY) === "1") {
    window.sessionStorage.removeItem(KEYCHAIN_LOGIN_SKIP_ONCE_KEY);
    return true;
  }
  return false;
}
